import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

interface SummaryCardProps {
  label: string;
  value: number | undefined;
  icon: LucideIcon;
  tone?: "default" | "accent" | "success" | "destructive";
  isLoading?: boolean;
}

const TONE_CLASSES: Record<NonNullable<SummaryCardProps["tone"]>, string> = {
  default: "bg-primary/10 text-primary",
  accent: "bg-accent/15 text-accent-foreground",
  success: "bg-success/15 text-success",
  destructive: "bg-destructive/10 text-destructive",
};

export function SummaryCard({ label, value, icon: Icon, tone = "default", isLoading }: SummaryCardProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">{label}</p>
        <div className={cn("flex h-8 w-8 items-center justify-center rounded-md", TONE_CLASSES[tone])}>
          <Icon className="h-4 w-4" />
        </div>
      </div>
      {isLoading ? (
        <Skeleton className="mt-2 h-8 w-16" />
      ) : (
        <p className="mt-1 font-display text-2xl font-semibold font-data">{value ?? 0}</p>
      )}
    </div>
  );
}
